import FormOfDonorData from '@/views/FormOfDonorData.vue'
import stepperGuard from '@/composables/stepperGuard'

export default {
  path: '/:childEditionId/dane-darczyncy',
  props: true,
  name: 'FormOfDonorData',
  component: FormOfDonorData,
  meta: {
    title: 'Wybór dziecka - Dane Darczyńcy - Ścieżka Wyboru Dzieci',
    metaTags: [{ name: 'robots', content: 'noindex' }]
  },
  beforeEnter: [stepperGuard]
}
